import zh from "./zh";
import en from "./en";

const resources = {
  zh,
  en,
};
export default resources;
